/* eslint-disable camelcase */
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ServerResponse } from "./axiosConfig";
import { useSwr } from "./axiosWIS";

export interface Severity extends Record<string, unknown> {
  id: string;
  pk_svrt_id: number;
  svrt_name: string;
  svrt_color: string;
  svrt_desc: string;
  svrt_is_default: boolean;
  svrt_status: string;
  created_by: string;
  create_timestamp: string;
  update_by: string;
  update_timestamp: string;
  inc_severity_order: number;
  version: number;
}

export const useSeverity = (
  config?: SWRConfiguration
): ServerResponse<ApiArrayResponse<Severity>> => {
  return useSwr<ApiArrayResponse<Severity>>(`/api/Severity`, config);
};
